module.exports = __webpack_public_path__ + "static/media/desarrollo7.f24cc433.png";